import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { AlertsModule } from "src/app/Components/alerts/alerts.module";
import { OrderCancellationComponent } from "./order-cancellation/order-cancellation.component";
import { OrderConfirmationComponent } from "./order-confirmation/order-confirmation.component";
import { OrdersRoutingModule } from "./order.module.routing";

@NgModule({
    declarations: [
        OrderCancellationComponent,
        OrderConfirmationComponent
    ],
    imports: [
        CommonModule,
        AlertsModule,
        OrdersRoutingModule
    ],

})

export class OrderModule { };